// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  spendId: __t.u64().primaryKey().name("spend_id"),
  groupId: __t.u64().name("group_id"),
  officer: __t.identity(),
  amountSov: __t.i64().name("amount_sov"),
  purpose: __t.string(),
  requiresVote: __t.bool().name("requires_vote"),
  approved: __t.bool(),
  executed: __t.bool(),
  voteClosesAt: __t.timestamp().name("vote_closes_at"),
  at: __t.timestamp(),
});
